import { Field } from 'formik';
import { MenuItem } from '@mui/material';
import { TextField } from 'formik-mui';
import PropTypes from 'prop-types';
import React from 'react';

import {
  ACCESS_TYPES,
  isApiGatewayAccessType,
  isBlankEndpointsJson,
  PLACEHOLDER_ENDPOINTS,
} from '../../../shared/account';

// How Arch reaches a customer account, and the configuration that only a
// gateway-connected one needs. Shared by the new and edit account forms so the
// two cannot drift; both hold `endpoints` as JSON text, which the form
// validates and the bundle parses.
const AccountGatewayFields = ({ values, setFieldValue }) => (
  <>
    <Field
      component={TextField}
      select
      name="accessType"
      label="Access Type"
      fullWidth
      margin="normal"
      variant="outlined"
      onChange={e => {
        const { value } = e.target;
        setFieldValue('accessType', value);
        // Offer the shape to fill in, rather than an empty box, the first time
        // an account becomes gateway-connected.
        if (
          isApiGatewayAccessType(value) &&
          isBlankEndpointsJson(values.endpoints)
        ) {
          setFieldValue(
            'endpoints',
            JSON.stringify(PLACEHOLDER_ENDPOINTS, null, 2),
          );
        }
      }}
    >
      {ACCESS_TYPES.map(type => (
        <MenuItem key={type.key} value={type.key}>
          {type.label}
        </MenuItem>
      ))}
    </Field>

    {isApiGatewayAccessType(values.accessType) && (
      <>
        <Field
          name="cdkBootstrapStackName"
          label="CDK Bootstrap Stack Name"
          component={TextField}
          fullWidth
          margin="normal"
          variant="outlined"
          placeholder="arch-cdk-bootstrap-stack"
        />

        <Field
          name="endpoints"
          label="Endpoints"
          component={TextField}
          helperText="API Gateway base URLs the backend calls, as JSON keyed by service."
          fullWidth
          multiline
          minRows={5}
          margin="normal"
          variant="outlined"
          placeholder={JSON.stringify(PLACEHOLDER_ENDPOINTS, null, 2)}
        />
      </>
    )}

    <Field
      name="customPermissionsBoundary"
      label="Custom Permissions Boundary"
      component={TextField}
      fullWidth
      margin="normal"
      variant="outlined"
      placeholder="arn:aws:iam::000000000000:policy/MyCustomPolicy"
    />
  </>
);

AccountGatewayFields.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  values: PropTypes.object.isRequired,
  setFieldValue: PropTypes.func.isRequired,
};

export default AccountGatewayFields;
